/**
 * Shared foreground detail for the source-footprint houses in the reviewed
 * Medinės Šnipiškės core. The geometry is intentionally plainer and lower
 * than the authored Žvėrynas villa family.
 */
export const SNIPISKES_BACKGROUND_DETAIL_CONFIG = Object.freeze({
  minimumFrontageM: 5.5,
  maximumStreetDistanceM: 34,
  maximumWindowColumns: 6,
  sidingCourseSpacingM: 0.5,
  minimumDoorClearanceM: 1.2,
  dormerSpacingM: 18,
  maximumDormerCount: 1,
});
